import { render, staticRenderFns } from "./FeatureTags.vue?vue&type=template&id=c2cceae6&"
import script from "./FeatureTags.vue?vue&type=script&lang=js&"
export * from "./FeatureTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports